<template>
  <div style="display: flex; flex-direction: row; overflow-x: auto; white-space: nowrap; margin: 10px 0">
    <div v-for="item in goods" :key="item.rgoods" @click="handleAdd(item)" style="flex: 0 0 auto; padding: 10px; margin-right: 10px; text-align: center; border: 1px solid #f5f7fa; border-radius: 8px; cursor: pointer;">
      <el-image style="width: 50px; height: 50px" :src="item.cmasterUrl" fit="fit"></el-image>
      <p>{{ item.cremark }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PickingChangeChoose",
  props: {
    storeId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      goods: [],
    };
  },
  methods: {
    handleSearch(barcodes, num) {
      this.topsAjax.get(`${this.baseUrls.viewProductPoolGoods}/goodsList`, { storeId: this.storeId, barcodes, num }).then((res) => {
        this.goods = res;
      });
    },
    handleAdd(item) {
      let arr = [item];
      this.$emit("OrderGoodsAdd", arr);
    }
  },
};
</script>

<style lang="scss">
.el-popover__title {
  text-align: center;
}

.input145px {
  .el-input {
    width: 145px !important;
  }
}
</style>
<style lang="scss" scoped>
.el-descriptions-item__content > p {
  color: black;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form-item__content {
  display: block;
}

.delivery-platform-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.remaining-time {
  color: green;
}

.overdue-time {
  color: red;
}

.delivery-block {
  height: 70px;
  width: 20%;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.hover-color:hover {
  /* 鼠标悬停时的样式 */
  background-color: rgba(64, 158, 255, 0.21);
}

.active {
  background-color: rgba(64, 158, 255, 0.21);
}
</style>
